const urls = {
  // documents details
  crudDocumentsDetailsOperations: `/api/Administrative/documents-operations/`,
  fetchImmobiliers: `/api/Administrative/immobiliers/`,
  fetchAllImmobiliers: `/api/domicile/immobiliers/`,
  // fetchVehicules: `/api/Administrative/immobiliers/`,
  fetchDocumentsTypes: `/api/Administrative/documents-types/`,
  fetchDocumentsFilter: `/api/Administrative/documents-filter/`,
  documentCreate: `/api/Administrative/document/create/`,
  deleteDocumentsBulkOperations: `/api/Administrative/delete-bulkoperations/`,
  // explorateur de documents (dossiers type OneDrive)
  crudDocumentFolders: `/api/Administrative/document-folders/`,
  fetchDocumentsTree: `/api/Administrative/documents-tree/`,
  moveDocumentsItems: `/api/Administrative/documents-move/`,

  // dashboard details
  crudDashboardDetailsOperations: `/api/Finance/dashboard-operations/`,
  fetchDashboardDetailsDonutChart: `/api/Finance/reports/`,
  fetchDashboardDetailsChartRevoBar: (slug) => `/api/Finance/chart-revo/${slug}`,
  fetchDashboardDetailsEvolutions: (slug) => `/api/Finance/dashboard-all/${slug}`,
  // operations
  deleteBulkOperations: `/api/Finance/delete-bulkoperations/`,
  deleteBulkOperationsM: `/api/Finance/delete-bulkoperations-m/`,
  addBulkOperations: `/api/Finance/add-bulkoperations/`,
  // mescompte(accounts)
  fetchAccounts: `/api/Finance/Accounts/`,
  fetchAllAccounts: `/api/Finance/AllAccounts/`,
  delAccounts: `/api/Finance/delele/accounts/`,
  // categorization
  fetchCategories: `/api/Finance/Categoriesfi/`,

  deleteBulkOperationsSocial: `/api/Social/delete-contact/`,
  crudSocialDashboardDetailsOperations: `/api/Social/dashboard-contacts/`,

  // general
  setQuestionaryTemps: `/api/general/questionarytemps/`,
  setQuestionaryTempsAnswer: `/api/general/set-questionary-temps-answer/`,
  RiskProfileQuestionary: `/api/general/risk-profile-questionary/`,
  BaseFiKnowledgeQuestionary: `/api/general/base-fi-knowledge-questionary/`,
  ProduitFiKnowledgeQuestionary: `/api/general/produit-fi-knowledge-questionary/`,
  BourseFiKnowledgeQuestionary: `/api/general/bourse-fi-knowledge-questionary/`,
  ImmobilierFiKnowledgeQuestionary: `/api/general/immobilier-fi-knowledge-questionary/`,
  FinalFiKnowledgeQuestionary: `/api/general/final-fi-knowledge-questionary/`,
  DeleteTaskSuggestTable: `/api/general/delete-DeleteTaskSuggestTable/`,
  userpriorityOpertation: `/api/general/userpriority/`,
  UpdateSuggest: `/api/general/update-suggest/`,
  // LAP-630: Event Suggestion endpoints
  getTaskSuggestions: `/api/general/task-suggestions/`,
  acceptTaskSuggestion: (id) => `/api/general/task-suggestions/${id}/accept/`,
  dismissTaskSuggestion: (id) => `/api/general/task-suggestions/${id}/dismiss/`,
  getUserContext: `/api/general/task-suggestions/user-context/`,
  generateInitialSuggestions: `/api/general/task-suggestions/generate-initial/`,
  getSimulationRate: `/api/general/get-simulation-rate/`,
  getCustomSimulation: `/api/Finance/custom-simulation/`,
  AddFinanceInterest: `/api/general/add-finance-interest/`,
  getCustomSimulationResul: `/api/general/get-custom-simulation/`,

  // mesobjectifs
  crudMesObjectifs: `/api/general/mesobjectifs/`,
  fetchMesObjectifsMetaData: `/api/general/mesobjectifs-metadata/`,
  bulkObjectifsAnnuler: `/api/general/mesobjectifs-bulkstatus/`,
  // LAP refonte Mes Objectifs — éléments rattachables (5 familles + objectifs
  // actifs pour le champ « Objectif lié » des popups projet / tâche).
  mesObjectifsLinkables: `/api/general/mesobjectifs-linkables/`,
  // POST {add:[{target_type,target_id}], remove:[link_id]} sur un objectif.
  mesObjectifsLinks: (id) => `/api/general/mesobjectifs/${id}/links/`,
  getSynthesTemps: `/api/general/synthese-temps-reports/`,
  MonBilanPatrimonialReports: `/api/general/mon-bilan-patrimonial-reports/`,
  PatrimonialScoreHistory: `/api/general/patrimonial-score/history/`,
  deleteUserObjectIfs: `/api/general/delete-userobjectives-bulkoperations/`,

  // domicile
  crudImmobilier: `/api/domicile/immobilier/`,
  bulkImmobilierFlag: `/api/domicile/immobilier-bulk-delete/`,
  immobilierImgDelte: `/api/domicile/imgdelete/`,
  addVContactOp: `/api/domicile/vehicle-contact/`,
  deleteVehicleContacts: `/api/domicile/vehicle-contact-delete/`,
  // personnal 2.0
  crudBucketList: `/api/Personnal/BucketList/`,
  crudRecettesOperations: `/api/Personnal/recette-operations/`,
  // Catalogue de recettes partagé (liste, puis `${id}/`, `${id}/publish/`, `${id}/add/`)
  recetteCatalog: `/api/Personnal/catalog/recettes/`,
  crudIngredientsOperations: `/api/Personnal/ingredients-operations/`,
  crudBillofingredientsOperations: `/api/Personnal/billofingredients-operations/`,
  crudInstructionOperations: `/api/Personnal/instruction-operations/`,
  crudRecettesCategoryOperations: `/api/Personnal/recette-category-operations/`,
  getFilters: `/api/Personnal/get-filters/`,
  getRecettes: `/api/Personnal/get-recettes/`,
  deleteBulkRecetteOperations: `/api/Personnal/delete-recette-bulkoperations/`,
  deleteBulkCategoryOperations: `/api/Personnal/delete-category-bulkoperations/`,
  deleteBulkBillofIngredients: `/api/Personnal/delete-billofingredient-bulkoperations/`,
  deleteBulkInstruction: `/api/Personnal/delete-Instruction-bulkoperations/`,
  planMealOperations: `/api/Personnal/PlanMeal/`,
  generateMenu: `/api/Personnal/genrate-menu/`,
  getIngredients: `/api/Personnal/get-ingredients/`,
  addIngredientsToTasks: `/api/Personnal/add-ingredients-to-task/`,
  // vehicle
  crudVkhmOperations: `/api/domicile/vhkm-operations/`,
  crudVhvalueOperations: `/api/domicile/vhvalue-operations/`,
  crudImmoValueOperations: `/api/domicile/immovalue-operations/`,
  getVkhmOperations: `/api/domicile/vhkm-table/`,
  deleteVkhmBulkOperations: `/api/domicile/delete-vhkmbulkoperations/`,
  deleteVhvalueBulkOperations: `/api/domicile/delete-vhvaluebulkoperations/`,
  deleteImmoValueBulkOperations: `/api/domicile/delete-immovaluebulkoperations/`,
  curdFinancement: `/api/domicile/Financement-operations/`,
  curdImmoFinancement: `/api/domicile/ImmoFinancement-operations/`,
  curdImmoFinancementDelete: `/api/domicile/immo-financment-delete/`,

  // Plan d'entretien
  crudEntretienOperations: `/api/domicile/entretien-operations/`,
  crudEntretienRealiserOperations: `/api/domicile/entretien-realiser-operations/`,
  deleteBulkEntretienOperations: `/api/domicile/delete-entretien-bulkoperations/`,
  deleteBulkOperationM: `/api/domicile/delete-bulkoperationm/`,
  updateDoneOperationM: `/api/domicile/update-doneoperationm/`,
  fetchPlanMaintenances: `/api/domicile/planMaintenances/`,

  // Mes Vehicles
  curdPlanFinancementViewDashboard: `/api/domicile/PlanFinancementViewDashboard/`,
  curdPlanImmoFinancementViewDashboard: `/api/domicile/ImmoPlanFinancementViewDashboard/`,
  fetchVehiclesTypes: `/api/domicile/vehicle-types/`,
  fetchVehicles: `/api/domicile/vehicles/`,
  crudVehiclesOperations: `/api/domicile/vehicle-operations/`,
  crudVehiclesFsiOperations: `/api/Finance/dashboard-operations/`,
  crudImmobilierFsiOperations: `/api/Finance/immobilier-fsi-operations/`,
  fetchMotorTypes: `/api/domicile/motor-types/`,
  fetchBoatTypes: `/api/domicile/boat-types/`,
  fetchCarPicModel: `/api/domicile/carpic-operations/`,
  fetchCarLogoModel: `/api/domicile/constructorlogo-operations/`,
  deleteBulkVehiclesOperations: `/api/domicile/delete-vehicle-bulkoperations/`,

  // budeget opertation api
  crudBudgetOpertations: `/api/Finance/budget-operations/`,
  crudBudgetSousCategoriesOpertations: `/api/Finance/budget-sous-categories/`,
  deleteBulkBudgetOperations: `/api/Finance/delete-bulkBudget-opertations/`,
  // LAP-768 — Compte de résultat personnel (mensuel / annuel + provisions)
  financeStatement: `/api/Finance/statement/`,
  financeStatementOperations: `/api/Finance/statement/operations/`,
  financeAutoCategorizeApply: `/api/Finance/auto-categorize/apply/`,
  financeProjectionSeed: `/api/Finance/statement/projection-seed/`,
  financeInternalTransfersDetect: `/api/Finance/internal-transfers/detect/`,
  financeInternalTransfersApply: `/api/Finance/internal-transfers/apply/`,
  financeSubscriptions: `/api/Finance/subscriptions/`,
  financeSubscriptionFlag: `/api/Finance/subscriptions/flag/`,
  financeSubscriptionCreateContract: `/api/Finance/subscriptions/create-contract/`,
  // LAP-PAT1 — Simulateur de décision (moteur de conséquences)
  financeDecisionSimulation: `/api/Finance/decision-simulation/`,
  // Search api
  getTables: `/api/search/tables/`,
  getSearch: `/api/search/search/`,
  getSuggestions: `/api/search/suggestion/`,

  // finance
  getAllFinanciers: `/api/Finance/Banks/`,
  accountOperations: `/api/Finance/account-operations/`,
  getFinanceInterest: `/api/Finance/finance-interest/`,
  getPredefinedEvents: `/api/Finance/predefined-events/`,
  CustomEventSimulation: `/api/Finance/custom-event-simulation/`,
  DeleteBulkTaxRate: `/api/Finance/delete-taxrates/`,
  TaxRateOperations: `/api/Finance/tax-rates-operations/`,
  UpdateSimulationRate: `/api/Finance/update-simulation-rate/`,
  // social

  getAllContacts: `/api/Social/get-all-contacts/`,
  //dashboard
  getQuestionAlimentation: `/api/Dashboard/question-alimentation/`,
  setEmissionAlimentation: `/api/Dashboard/set-alimentation/`,

  // Garden
  getPlantList: '/api/garden/dashboard-plant/',
  getMyPlant: '/api/garden/dashboard-Myplant/',
  crudPlant: '/api/garden/MyPlantList/',
  myPlantsBulkDelete: '/api/garden/myplants-bulk-delete/',

  // Professional
  crudParcoursProOperations: '/api/Professional/parcours-operations/',
  companyOperations: '/api/Professional/company-operations/',
  getParcoursPro: '/api/Professional/getParcoursPro/',
  fetchCompanys: `/api/Professional/getCompanys/`,
  fetchCompetence: `/api/Professional/getCompetence/`,
  deleteBulkParcoursOperations: `/api/Professional/delete-parcours-bulkoperations/`,

  // MesToDo
  getAllCheckList: `/api/mestodo/getCheckList/`,
  getDomain: `/api/mestodo/getDomain/`,
  checkListOperations: `/api/mestodo/checklist-operations/`,
  taskOperations: `/api/mestodo/task-operations/`,
  noteOperations: `/api/mestodo/note-operations/`,
  commentOperations: `/api/mestodo/comment-operations/`,
  projectOperations: `/api/mestodo/project-operations/`,
  listeOperations: `/api/mestodo/liste-operations/`,
  fetchTasks: `/api/mestodo/getTasks/`,
  OrganisationScoreHistory: `/api/mestodo/organisation-score/history/`,
  habitCheckin: `/api/mestodo/habit-checkin/`,
  kpiIncrement: `/api/mestodo/kpi-increment/`,
  kpiToObjective: `/api/mestodo/kpi-to-objective/`,
  deleteBulkTachesOperations: `/api/mestodo/delete-taches-bulkoperations/`,
  deleteBulkProjectOperations: `/api/mestodo/delete-project-bulkoperations/`,
  deleteBulkListeOperations: `/api/mestodo/delete-liste-bulkoperations/`,
  faitBulkTachesOperations: `/api/mestodo/fait-taches-bulkoperations/`,
  enCoursBulkTachesOperations: `/api/mestodo/encours-taches-bulkoperations/`,

  // time
  getAllTimeCatgory: `/api/time/get-category-dd`,
  // user
  register: `/api/user/register/`,
  login: `/api/user/login/`,
  uploadImg: `/api/user/upload-img/`,

  // Shopping
  shoppingLists: `/api/shopping/lists/`,
  shoppingItems: `/api/shopping/items/`,
  itemLibrary: `/api/shopping/library/`,
  shoppingAisles: `/api/shopping/aisles/`,
  shoppingStatistics: `/api/shopping/statistics/`,
  
  // Recipe & Meal Planning endpoints (for Shopping integration)
  planMealOperations: `/api/Personnal/PlanMeal/`,
  billOfIngredients: `/api/Personnal/billofingredients-operations/`,

  // Roadmap
  roadmapIdeas: `/api/roadmap/ideas/`,
  roadmapLinks: `/api/roadmap/links/`,
  roadmapRollover: `/api/roadmap/rollover/`,
  roadmapEvents: `/api/roadmap/events/`,
  // Smart Feed endpoints
  smartFeedBase: `/api/smartfeed`,
  smartFeedRefresh: `/api/smartfeed/refresh/`,
  smartFeedInteract: (id) => `/api/smartfeed/${id}/interact/`,
  smartFeedSaved: `/api/smartfeed/saved/`,
  smartFeedPreferences: `/api/smartfeed/preferences/`,
  smartFeedDefinitions: `/api/smartfeed/definitions/`,
  smartFeedSubscription: `/api/smartfeed/subscription/`,

  // Tax Intelligence Engine (/api/tax/*)
  taxProfile: `/api/tax/profile`,
  taxPosition: `/api/tax/position`,
  taxRecalculate: `/api/tax/recalculate`,
  taxRules: `/api/tax/rules`,
  taxReadiness: `/api/tax/readiness`,
  taxMissingInformation: `/api/tax/missing-information`,
  taxAnswerQuestion: (id) => `/api/tax/questions/${id}/answer`,
  taxCoverage: `/api/tax/coverage`,
  taxCopilotQuery: `/api/tax/copilot/query`,
  taxFacts: `/api/tax/facts/`,
  taxOpportunities: `/api/tax/opportunities/`,
  taxCalendar: `/api/tax/calendar/`,
  taxDocuments: `/api/tax/documents/`,
  taxScenarios: `/api/tax/scenarios/`,
  taxOperations: `/api/tax/operations`,
  taxOperationTags: `/api/tax/operation-tags/`,
  taxOperationTag: (id) => `/api/tax/operation-tags/${id}/`,
}

export default urls
